// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHeader_root__120jW","addProfileBtn":"PageHeader_addProfileBtn__3X-Ui"};